import { instance } from "apis/interceptor";

//* 연장 요청 답변 전송 api
export const sendMeetingExtendsResponse = async (meetingExtensionId: string, state: boolean) => {
  try {
    const res = await instance.post(`/back-office/slack/meeting/extend/response`, {
      meetingExtensionRequestId: meetingExtensionId,
      isAccepted: state,
    });
    return { success: res.data.result };
  } catch (error: any) {
    return { success: false, message: "연장 요청을 처리할 수 없습니다." };
  }
};
